<template>
  <div>
    <Navbar ref="mainNavbar">
      <template v-slot:menu>
        <DefaultNavbar :navitems="menu" @close="handleClose" />
      </template>
    </Navbar>
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/Index.scss";
import Navbar from "./navbar/Navbar";
import DefaultNavbar from "./navbar/components/DefaultNavbar";
import { mapState } from "vuex";

export default {
  components: {
    Navbar,
    DefaultNavbar,
  },
  data() {
    return {
      cartData: [],
      cart: [],
      items: [],
      student: [],
    };
  },

  computed: {
    isLoggedIn() {
      return this.user && this.user._id != null;
    },
    ...mapState("auth", ["user"]),
    ...mapState("campaignPageBanner", ["getMasterCampaign"]),

    // ...mapState("student", ["students"]),
    // courses() {
    //   return this.cartData.map((items) => items.courses);
    // },

    menu() {
      let data = this.$route.fullPath.includes("e-learning")
        ? [
            {
              text: "Overview",
              route: "e-home",
            },
            {
              text: "My Learning",
              route: "e-my-learning",
            },
            {
              text: "Wishlist",
              route: "e-wishlist",
            },
            {
              // text: "Cart " + this.userData.student.cart.length,
              text: "Cart ",
              route: "e-cart",
            },
          ]
        : this.$route.fullPath.includes("map-inside") ||
          this.$route.fullPath.includes("schedule-page") ||
          this.$route.fullPath.includes("booking-page") ||
          this.$route.fullPath.includes("transaction") ||
          this.$route.fullPath.includes("user-profile")
        ? [
            {
              text: "Home",
              route: "home",
            },
            {
              text: "Request a Service",
              route: "post a requirement",
            },
            // {
            //   text: "Become a Service Provider",
            //   route: "become a service provider",
            // },
            {
              text: "My Transactions",
              route: "transaction",
              // hasSubmenu: true,
              // submenu: [
              // {
              //   text: "My Booking",
              //   route: "booking-page",
              // },
              // {
              //   text: "My Transactions",
              //   route: "transaction",
              // },
              // {
              //   text: "Healthcare Professionals",
              //   route: "hcp",
              // },
              // ],
            },
            {
              text: "Contact Us",
              route: "contact-us",
            },
          ]
        : this.$route.fullPath.includes("heartofcare")
        ? [
            {
              text: "Home",
              route: "heartofcare",
            },
            {
              text: "About",
              route: "about",
            },
            {
              text: "Master Classes",
              route: "master-class",
            },
            {
              text: "Gallery",
              route: "heartofcareGallery",
            },
            {
              text: "Contact",
              route: "connect",
            },
            {
              text: "Share Your Work",
              route: "sharework",
            },
          ]
        : [
            {
              text: "Individuals",
              hasSubmenu: true,
              submenu: [
                {
                  text: "Caregiver",
                  route: "caregiver",
                },
                {
                  text: "Well-wisher",
                  route: "wellwisher",
                },
                {
                  text: "Healthcare Professional",
                  route: "hcp",
                },
              ],
            },

            // {
            //   text: "Corporate",
            //   route: "corporate",
            // },
            {
              text: "Corporate",
              route: "corporate",
            },
            {
              text: "Resources",
              hasSubmenu: true,
              submenu: [
                {
                  text: "News",
                  route: "news",
                },
                {
                  text: "Blogs",
                  route: "insights-blogs",
                },
                {
                  text: "Events",
                  route: "events",
                  // icon: "LockIcon",
                },
                {
                  text: "Gallery",
                  route: "insights-gallery",
                },
                {
                  text: "E-Learning",
                  route: "e-home",
                  // icon: "LockIcon",
                },
                {
                  text: "Podcasts",
                  route: "podcast",
                  // icon: "LockIcon",
                },
                {
                  text: "ToolKits / Downloads",
                  route: "toolsandhandbook",
                  // icon: "LockIcon",
                },
                {
                  text: "Regulations,Policies & Paper",
                  route: "regulation-policies-papers",
                  // icon: "LockIcon",
                },
                {
                  text: "Heart of Care",
                  route: "heartofcare",
                },
                {
                  text: "Videos",
                  route: "playlists",
                  // icon: "LockIcon",
                },
                {
                  text: "Care Directory",
                  route: "Care Directory",
                  // icon: "LockIcon",
                },
              ],
            },
            // {
            //   text: "Insights",
            //   hasSubmenu: true,
            //   submenu: !this.isLoggedIn
            //     ? [
            //         {
            //           text: "News",
            //           route: "news",
            //         },
            //       ]
            //     : [
            //         {
            //           text: "News",
            //           route: "news",
            //         },
            //         {
            //           text: "Events",
            //           route: "events",
            //         },
            //         {
            //           text: "Blog",
            //           route: "insights-blogs",
            //         },
            //         {
            //           text: "Podcast",
            //           route: "podcast",
            //         },
            //         {
            //           text: "Self-help Tools",
            //           route: "toolsandhandbook",
            //         },
            //       ],
            // },

            {
              text: "Explore",
              hasSubmenu: true,
              submenu: [
                {
                  text: "Request for Service",
                  route: "request-form",
                  path: "request-for-service",
                },
                {
                  text: "Corporate Services/ Partnership",
                  route: "request-form",
                  path: "corporate-service-partnership",
                },
                {
                  text: "Partner With Us",
                  route: "request-form",
                  path: "partner-with-us",
                },
                {
                  text: "Work at CGS",
                  route: "request-form",
                  path: "work-at-cgs",
                },
                {
                  text: "Share your Story/ Expertise with us",
                  route: "request-form",
                  path: "share-your-story-expertise",
                },
                {
                  text: "Register for Events",
                  route: "request-form",
                  path: "register-for-events",
                },
                {
                  text: "Register for Programmes",
                  route: "request-form",
                  path: "register-for-programmes",
                },
                {
                  text: "About Us",
                  route: "about-us",
                },
                {
                  text: "Community",
                  route: "community",
                },
                {
                  text: "Careers",
                  route: "careers",
                },
                {
                  text: "Caregiver Coach Certification",
                  route: "coach",
                },
                // {
                //   text: "Testimonial",
                //   route: "home",
                // },
              ],
            },
          ];
      if (this.getMasterCampaign.campaignPageVisible) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].text == "Resources") {
            data[2].submenu.push({
              text: "Campaign",
              route: "aboutcampaign-user",
            });
          }
        }
      }
      return data;
    },
  },

  methods: {
    handleClose() {
      this.$refs.mainNavbar.$refs.closeOption.toggle();
    },
    // displaydata() {
    //   val = cartData.length;
    //   console.log(val);
    // },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
